// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605261133/js/" + chunkId + "." + {"44":"14fb22dc","225":"26a1b6f0","481":"19fdbd1c","486":"e6dfd387","770":"b0a0e4e5"}[chunkId] + ".0.9588644275026988.chunk.js";
};